export default function camelize(str, initCapitalize = true, replaceChar = "") {
  const camelizeRE = /-(\w)/g;
  str = str.replace(/_/g, "-").replace(camelizeRE, (_, c) => {
    return c ? replaceChar + c.toUpperCase() : "";
  });

  return initCapitalize ? str[0].toUpperCase() + str.slice(1) : str;
}
